var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('section',[_c('div',{staticClass:"max-width"},[_c('AlertBox',{attrs:{"type":"danger","text":"Oh no! Your trial has expired :-("}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }